// TanStack Query with the same defaults as Kotlin's QueryClient (10 § 3): 30 s stale, 5 min gc,
// refetch on focus; only idempotent server failures are retried. Every failure goes through routeError: a read with no
// data yet is a state frame part's, which shows the error itself. A write runs whatever the network says, so offline it
// fails at once and says it needs a connection — never paused and sent later (D193, D39).
import { ApiError } from '@orca/api-client'
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query'
import { routeError } from '../errors/routeError'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => routeError(error, query.state.data === undefined ? 'part' : 'query'),
  }),
  mutationCache: new MutationCache({ onError: (error) => routeError(error, 'mutation') }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: true,
      retry: (failures, error) =>
        failures < 3 &&
        error instanceof ApiError &&
        (error.effectiveCode === 'internal_error' || error.effectiveCode === 'maintenance'),
    },
    mutations: { retry: false, networkMode: 'always' },
  },
})
